import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const AssigneeFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: organizationMembers } = useCurrentOrganizationMembers();
    const { assigneeIds } = filters;

    const labels = useMemo(
        () =>
            organizationMembers
                ?.filter((member) => assigneeIds?.includes(member.user.id))
                .map((member) => member.user.name) ?? [],
        [organizationMembers, assigneeIds],
    );

    if (!assigneeIds || assigneeIds.length === 0) {
        return null;
    }

    return formatFilterLabel(labels);
};
